import * as React from "react";
import { Input, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { ServiceContext } from "src/services/provider/Service.provider";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import "./FindExpense.scss";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as _ from "lodash";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { IExpenseBasicInfo } from 'src/services/interfaces/Expense/IExpenseBasicInfo';
import { IExpenseDetail } from 'src/services/interfaces/Expense/IExpenseDetail';
import { IQueryExpensesBasicInfo } from 'src/services/interfaces/IQueryExpensesBasicInfo';
import { ExpenseStatusEnum } from 'src/services/Enum/ExpenseStatusEnum';
import { SearchExpenseCategoryEnum, SearchExpenseCategoryLabel } from 'src/services/Enum/SearchExpenseCategoryEnum';

interface IFindExpenseProps {
  onChangeList: (value: IExpenseBasicInfo[]) => void;
  onChangeCurrentValue: (value: IExpenseDetail) => void;
  onChangeShouldReloadList: (value: boolean) => void;
  setLoadingList: React.Dispatch<React.SetStateAction<boolean>>;
  shouldReloadList: boolean;
  listStatus?: ExpenseStatusEnum[];
}

export const FindExpense: React.FC<IFindExpenseProps> = ({
  onChangeList,
  onChangeCurrentValue,
  onChangeShouldReloadList,
  setLoadingList,
  shouldReloadList,
  listStatus
}) => {
  const { expenseSearchService } = useContext(ServiceContext);
  const [searchInput, setSearchInput] = useState<string>("");
  const [searchBy, setSearchBy] = useState<SearchExpenseCategoryEnum>(SearchExpenseCategoryEnum.NONE);
  const [qtyExpenses, setQtyExpenses] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const defaultSearchBy = SearchExpenseCategoryEnum.NONE;

  useEffect(() => {
    if (shouldReloadList) {
      searchExpenses(SearchExpenseCategoryEnum.NONE);
      onChangeShouldReloadList(false);
    }

  }, [shouldReloadList]);

  useEffect(() => {
    if (searchBy === SearchExpenseCategoryEnum.NONE) {
      searchExpenses(SearchExpenseCategoryEnum.NONE);
    }
  }, [searchBy]);

  function submitSearch(e) {
    if (e.charCode === 13) {
      searchExpenses();
    }
  }

  const loadFilterParams = (overrideSearchBy?: SearchExpenseCategoryEnum): IQueryExpensesBasicInfo => {
    return {
      status: listStatus,
      searchBy: overrideSearchBy ?? searchBy,
      searchInput,
    };
  }

  function searchExpenses(overrideSearchBy?: SearchExpenseCategoryEnum) {
    if (!searchInput && searchBy !== SearchExpenseCategoryEnum.NONE) {
      return ShowNotification.Warn("Campo obrigatório!", "Preencha o campo para pesquisar");
    }

    onChangeCurrentValue(null);
    onChangeList([]);
    setQtyExpenses(null);
    setLoadingList(true);
    setLoading(true);
    expenseSearchService
      .getBasicInfo(loadFilterParams(overrideSearchBy))
      .then(resp => {
        if (resp) {
          setQtyExpenses(resp.qtyExpenses);
          onChangeList(resp.expenses);
        }
      })
      .catch(err => ShowNotification.Error("Falhar ao buscar a solicitação de pagamento", "Não foi possível buscar, tente novamente"))
      .finally(() => {
        setLoading(false);
        setLoadingList(false);
      });
  }

  return (
    <>
      <div className="wrapper">
        <PbrSelect
          name="searchBy"
          size="large"
          defaultValue={SearchExpenseCategoryLabel.get(defaultSearchBy)}
          value={searchBy}
          onChange={e => setSearchBy(e as SearchExpenseCategoryEnum)} showSearch>
          <Select.Option value="Pesquisar por..." disabled>
            Pesquisar por...
          </Select.Option>
          {Object.keys(SearchExpenseCategoryEnum).map(value => (
            <Select.Option key={value} value={value}>
              {SearchExpenseCategoryLabel.get(SearchExpenseCategoryEnum[value])}
            </Select.Option>
          ))}
        </PbrSelect>

        <Input
          className="find-expense-input"
          value={searchInput}
          name="searchTrade"
          onChange={e => setSearchInput(e.target.value)}
          placeholder="Preencha para pesquisar"
          onKeyPress={submitSearch}
        />
        <button disabled={loading} className="find-expense-button btn icon-only" onClick={() => searchExpenses()}>
          <FontAwesomeIcon icon={faSearch} />
        </button>
        <div className="left-bold">
          Qtd de solicitações: <span className="total-expense-count">{qtyExpenses}</span>
        </div>
      </div>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/FindExpense/FindExpense.tsx